import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-patient-feedback-card',
  templateUrl: './patient-feedback-card.component.html',
  styleUrls: ['./patient-feedback-card.component.css']
})
export class PatientFeedbackCardComponent implements OnInit {

  constructor() { }

  @Input() cases;
  @Output() viewAction = new EventEmitter();
  @Output() sendAction = new EventEmitter();

  ngOnInit() {
  }

  viewFeedback(data) {
    this.viewAction.emit(data);

  }

  sendFeedback(data) {
    this.sendAction.emit(data);

  }


}
